import React from 'react'
import {
  ThemeProvider,
  ColorModeProvider,
  CSSReset,
  theme
} from '@chakra-ui/core'
import PWAPrompt from 'react-ios-pwa-prompt'
import megalithlogo from './megalithlogo'
import megalithicon from './megalithicon'
import MainComponent from './MainComponent';

function App() {
  //theme.fonts.body='"Montserrat", Arial, sans-serif;';
  //theme.fonts.body='Menlo, monospace';
  theme.icons.megalithlogo = megalithlogo();
  theme.icons.megalithicon = megalithicon();
  return (
  <ThemeProvider theme={theme}>
    <ColorModeProvider>
      <CSSReset />
      <PWAPrompt
        promptOnVisit={4}
        timesToShow={1}
        permanentlyHideOnDismiss={false}
        copyTitle="Zum Home-Bildschirm hinzufügen"
        copyBody="Diese Website kann direkt als App auf Ihrem Gerät installiert werden. Fügen Sie sie einfach zu Ihrem Home-Bildschirm hinzu."
        copyShareButtonLabel="1) 'Teilen' drücken"
        copyAddHomeButtonLabel="2) 'Zum Home-Bildschirm' auswählen"
        copyClosePrompt="Schliessen"
      />
      <MainComponent/>
    </ColorModeProvider>
  </ThemeProvider>
  );
}

export default App;